export default __webpack_public_path__ + "static/media/30.315fcc6d.mp3";